export const CABINET_RUNTIME_HANDLE_TAG = 'cabinetRuntimeHandle';

export function isRuntimeCabinetHandle(object) {
  return Boolean(object && object.userData && object.userData[CABINET_RUNTIME_HANDLE_TAG]);
}

export function markRuntimeCabinetHandle(object) {
  if (!object) {
    return;
  }

  object.traverse((child) => {
    child.userData[CABINET_RUNTIME_HANDLE_TAG] = true;
  });
}

// Runtime handles share cached geometry with their source model. Detach them
// without disposing shared assets so a handle can be replaced in the live scene.
export function removeRuntimeCabinetHandles(root) {
  if (!root) {
    return;
  }

  const handleRoots = [];
  root.traverse((child) => {
    if (
      isRuntimeCabinetHandle(child)
      && (!child.parent || !isRuntimeCabinetHandle(child.parent))
    ) {
      handleRoots.push(child);
    }
  });

  handleRoots.forEach((handleRoot) => {
    if (handleRoot.parent) {
      handleRoot.parent.remove(handleRoot);
    }
  });
}
